import styled from "styled-components";
import { colorsPalettes, mixins } from "@similarweb/styles";

export const StyledText = styled.p`
    ${mixins.setFont({ $color: colorsPalettes.midnight["100"], $size: 16 })};
    line-height: 20px;
    margin-top: 7px;
    max-width: 180px;
    text-align: center;
`;

export const StyledEmptyTabContainer = styled.div<{ height: number }>`
    align-items: center;
    display: flex;
    flex-direction: column;
    height: ${({ height }) => `${height}px`};
    justify-content: center;

    & .SWReactIcons svg path {
        fill: ${colorsPalettes.midnight["100"]};
    }
`;
